import { render, staticRenderFns } from "./freezing-info-data.vue?vue&type=template&id=2fff6eac&"
import script from "./freezing-info-data.vue?vue&type=script&lang=js&"
export * from "./freezing-info-data.vue?vue&type=script&lang=js&"
import style0 from "./freezing-info-data.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports